import React from "react";
// import _ from 'lodash'
// import MultiLineText from './MultiLineText';
import BG from "./img/1.png";
import BG_cn from "./img/1-cn.png";
import BG_ru from "./img/1-ru.png";
import BG_en from "./img/1-en.png";

export default ({ currentLang, selectedType }) => {
  const shouldDisplayByLang = (selectLang) => {
    return currentLang === selectLang ? "display" : "display-none";
  };
  const shouldDisplayByType = (type) => {
    return selectedType === type || selectedType === "all"
      ? "opacity-in"
      : "opacity-out";
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 500"
      data-name="Layer 1"
      className="site-plan-svg"
      width={1200}
      height={1200}
    >
      {/* <g id="map">
        <image xlinkHref={BG} height="100%" width="100%" />
      </g> */}
      <g id="map">
        <image
          className={shouldDisplayByLang("cn")}
          xlinkHref={BG_cn}
          height="100%"
          width="100%"
        />
        <image
          className={shouldDisplayByLang("ru")}
          xlinkHref={BG_ru}
          height="100%"
          width="100%"
        />
        <image
          className={shouldDisplayByLang("en")}
          xlinkHref={BG_en}
          height="100%"
          width="100%"
        />
      </g>
      <g id="floorplan">
        <g id="studio" className={shouldDisplayByType("studio")}>
          <polygon
            points="138.91 250.54 135.15 254.3 135.15 254.3 137.82 256.97 145.58 264.73 145.93 264.38 145.96 264.42 149.4 260.98 148.91 260.49 157.94 251.45 158.09 251.6 162.5 247.2 162.32 247.02 163.98 245.37 146.46 227.84 131.34 242.96 138.91 250.54"
            fill="#231f20"
          />
          {/* <polygon
            id="_1A_1112"
            data-name="1A_1112"
            points="201.7 63.2 201.7 68.6 212.4 68.6 212.4 90.4 186.9 90.4 186.9 63.2 201.7 63.2"
            fill="#231f20"
          />
          <polygon
            id="_1A_1105"
            data-name="1A_1105"
            points="94.7 140.9 94.7 132.4 107.7 119.4 107.7 97.6 134.5 97.6 134.5 140.9 94.7 140.9"
            fill="#231f20"
          /> */}
        </g>
        <g id="one-bedroom" className={shouldDisplayByType("one-bedroom")}>
          <polygon
            points="143.79 228.44 145.5 226.72 128 209.22 112.85 224.37 112.32 223.84 105.56 230.6 116.19 241.23 119.58 237.83 126.99 245.24 139.44 232.78 139.66 233 144 228.65 143.79 228.44"
            fill="#231f20"
          />
        </g>
        <g id="two-bedroom" className={shouldDisplayByType("two-bedroom")}>
          <polygon
            points="182.17 301.23 178.79 304.61 197.71 323.52 204.83 316.39 204.52 316.08 207.15 313.44 207.28 313.57 218.1 302.75 217.97 302.62 219.63 300.97 192.66 274 173.8 292.86 182.17 301.23"
            fill="#231f20"
          />
          <polygon
            points="216.39 248.67 197.74 230.02 194.03 233.73 185.72 225.42 170.58 240.57 197.47 267.46 197.51 267.42 197.58 267.49 216.39 248.67"
            fill="#231f20"
          />
          <polygon
            points="334.22 206.6 316.29 224.5 324.61 232.75 324.51 232.88 329.71 238.08 329.88 237.91 331.52 239.55 358.39 212.68 339.53 193.82 330.49 202.86 334.22 206.6"
            fill="#231f20"
          />
          <polygon
            points="148.15 187.8 130.25 169.86 122 178.18 121.87 178.08 116.67 183.29 116.84 183.46 115.2 185.09 142.07 211.96 160.93 193.1 151.88 184.06 148.15 187.8"
            fill="#231f20"
          />
          <polygon
            points="371.02 169.74 367.24 165.96 340.11 193.09 349.55 202.52 349.65 202.43 359.1 211.88 385.98 185 384.31 183.33 384.46 183.18 373.67 172.4 373.54 172.53 370.89 169.87 371.02 169.74"
            fill="#231f20"
          />
          <polygon
            points="184.97 224.65 188.75 220.87 161.63 193.74 152.19 203.18 152.29 203.28 142.84 212.73 169.72 239.61 171.39 237.94 171.54 238.09 182.32 227.3 182.19 227.17 184.84 224.52 184.97 224.65"
            fill="#231f20"
          />
          <polygon
            points="149.68 261.3 145.9 265.08 173.03 292.21 182.46 282.77 182.37 282.68 191.82 273.22 164.94 246.34 163.27 248.01 163.12 247.87 152.34 258.65 152.47 258.78 149.81 261.43 149.68 261.3"
            fill="#231f20"
          />
          <polygon
            points="330.41 240.47 328.82 238.87 328.84 238.85 325.77 235.78 325.69 235.86 317.97 228.15 318.05 228.06 315.43 225.44 315.83 225.04 312.02 221.23 302.61 230.63 306.35 234.37 288.36 252.36 303.43 267.44 330.41 240.47"
            fill="#231f20"
          />
          <polygon
            points="225.42 295.16 227.01 293.56 227.03 293.59 230.1 290.52 230.02 290.43 237.74 282.71 237.82 282.8 240.45 280.18 240.84 280.57 244.65 276.76 235.25 267.36 231.51 271.09 213.52 253.1 198.44 268.18 225.42 295.16"
            fill="#231f20"
          />
        </g>
      </g>
      <g xmlns="http://www.w3.org/2000/svg" id="text">
        <g id="cn" className={shouldDisplayByLang("cn")}>
          <text
            transform="translate(244 160)"
            fontSize="10"
            fill="#58595b"
            font-family="Termina-Bold, Termina Bold"
          >
            1 楼
          </text>
        </g>
        <g id="ru" className={shouldDisplayByLang("ru")}>
          <text
            transform="translate(226 160)"
            fontSize="11"
            fill="#58595b"
            font-family="Helvetica-Bold, Helvetica"
            font-weight="700"
          >
            1-Й ЭТАЖ
          </text>
        </g>
        <g id="en" className={shouldDisplayByLang("en")}>
          <text
            transform="translate(234 160)"
            fontSize="10"
            fill="#58595b"
            font-family="Termina-Bold, Termina Bold"
            font-weight="700"
          >
            1st Floor
          </text>
        </g>
      </g>
    </svg>
  );
};



// WEBPACK FOOTER //
// ./src/data/PhuketSkypark/sitePlan/svg/a/1.js